import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { SectorSection } from '../components/SectorSection';
import { MarketingSection } from '../components/MarketingSection';
import { ComparativaSection } from '../components/ComparativaSection';
import { IntegrationsSection } from '../components/IntegrationsSection';
import { PositioningPillarsSection } from '../components/PositioningPillarsSection';
import { UseCaseLinksSection } from '../components/UseCaseLinksSection';
import { SalesAgentsSection } from '../components/SalesAgentsSection';
import { PricingSection } from '../components/PricingSection';
import { SuccessStories } from '../components/SuccessStories';
import { HowItWorks } from '../components/HowItWorks';
import { QuienesSomos } from '../components/QuienesSomos';
import { FAQSection } from '../components/FAQSection';

export const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <PositioningPillarsSection />
      <UseCaseLinksSection />
      <IntegrationsSection />
      <FeaturesSection />
      <SalesAgentsSection />
      <SectorSection />
      <MarketingSection />
      <ComparativaSection />
      <PricingSection />
      <SuccessStories />
      <HowItWorks />
      <QuienesSomos />
      <FAQSection />
    </>
  );
};